var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CubeWithTarget.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CubeWithTarget = ({
  color = '#00003D',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.7544 5.19815C12.2878 4.93371 11.7122 4.93371 11.2456 5.19815L5.80111 8.22371L9.74444 10.4093C10.3122 9.81815 11.1133 9.44482 12 9.44482C12.8867 9.44482 13.6878 9.81815 14.2556 10.4093L18.1989 8.21593L12.7544 5.19815ZM10.4444 12.5559C10.4444 11.7004 11.1444 11.0004 12 11.0004C12.8556 11.0004 13.5556 11.7004 13.5556 12.5559C13.5556 13.4115 12.8556 14.1115 12 14.1115C11.1444 14.1115 10.4444 13.4115 10.4444 12.5559ZM5 9.55371L8.99 11.7704C8.92 12.0193 8.88889 12.2837 8.88889 12.5559C8.88889 14.0026 9.87667 15.2237 11.2222 15.5659V19.8981L5.80111 16.8881C5.30333 16.6159 5 16.0948 5 15.527V9.55371ZM12.7778 19.8981V15.5659C14.1233 15.2237 15.1111 14.0026 15.1111 12.5559C15.1111 12.2837 15.08 12.0193 15.01 11.7704L19 9.55371V15.527C19 16.0948 18.6967 16.6159 18.1989 16.8881L12.7778 19.8981Z",
    fill: "white"
  })]
});